const parentHeight = 40;
const parentPadding = 6;

const chipHeight = parentHeight - parentPadding * 2;

export const tokens = {
    padding: 4,
    height: chipHeight,
    symbolSize: 20,
    iconSize: 12,
    labelSize: 12,
};
